
import { watch, onMounted } from 'vue'
import 'ress'
import '@/styles/main.scss'
import ModalSearch from '@/components/genenral/ModalSearch.vue'
import ModalLimited from '@/components/genenral/ModalLimited.vue'
import ModalScoringCriteria from '@/components/genenral/ModalScoringCriteria.vue'
import ModalSystemError from '@/components/genenral/ModalSystemError.vue'
import PageLoader from '@/components/genenral/PageLoader.vue'
import { useStore } from 'vuex'
import { useRoute } from 'vue-router'
import { provideSpecial } from './provider/special'
import { provideTest } from './provider/test'
import { provideRecommend } from './provider/recommend'
import { provideEvent } from './provider/event'
import { provideAdBanners } from './provider/adBanners'
import { provideTopSpecialFeatures } from './provider/topSpecialFeatures'

export default {
  name: 'App',

  components: {
    ModalSearch,
    ModalLimited,
    ModalScoringCriteria,
    ModalSystemError,
    PageLoader
  },

  setup() {
    const store = useStore()
    const route = useRoute()
    provideSpecial()
    provideTest()
    provideRecommend()
    provideEvent()
    provideTopSpecialFeatures()
    provideAdBanners()

    // 本当はこれを使う
    window.addEventListener('focus', () => {
      store.dispatch('getUserInfo')
    })

    watch(
      () => route.path,
      () => {
        if (store.state.visibleSearchModal) store.dispatch('closeSearchModal')
        if (store.state.visibleLimitedModal) store.dispatch('closeLimitedModal')
        if (store.state.systemError.show) store.commit('closeSystemError')
      }
    )

    onMounted(() => {
      // イベント参加病院を取得しておく
      store.dispatch('updateEventParticipatingHospitals')
    })
  }
}
